import { initializeApp, getApps, getApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyBDDYBWuz03zLPZwdIdcfWVfB9gTLi9-QE",
    authDomain: "trade-25061.firebaseapp.com",
    databaseURL: "https://trade-25061-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "trade-25061",
    storageBucket: "trade-25061.firebasestorage.app",
    messagingSenderId: "37954385434",
    appId: "1:37954385434:web:27311bffa67822197b43a3",
    measurementId: "G-VD2MGESDQ7",
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const getMessagingInstance = async () => {
    const supported = await isSupported();

    if (!supported) return null;

    return getMessaging(app);
};

export default app;